import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SalesPerformanceOverview } from "@/components/sales/analytics/SalesPerformanceOverview";
import { SegmentAnalysis } from "@/components/sales/analytics/SegmentAnalysis";
import { SalesForecasting } from "@/components/sales/analytics/SalesForecasting";
import { ReportBuilder } from "@/components/sales/analytics/ReportBuilder";

const SalesAnalytics: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-heading font-bold text-primary-700">Sales Analytics & Reports</h1>
        <p className="text-gray-600">Comprehensive sales performance insights and forecasting</p>
      </div>

      <Tabs defaultValue="performance" className="space-y-6">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="performance">Performance Overview</TabsTrigger>
          <TabsTrigger value="segments">Segment Analysis</TabsTrigger>
          <TabsTrigger value="forecasting">Sales Forecasting</TabsTrigger>
          <TabsTrigger value="reports">Report Builder</TabsTrigger>
        </TabsList>

        <TabsContent value="performance">
          <SalesPerformanceOverview />
        </TabsContent>

        <TabsContent value="segments">
          <SegmentAnalysis />
        </TabsContent>

        <TabsContent value="forecasting">
          <SalesForecasting />
        </TabsContent>

        <TabsContent value="reports">
          <ReportBuilder />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SalesAnalytics;